import Vue from "vue";
import { sync } from "vuex-router-sync";
import VTooltip from "v-tooltip";
import VueAxios from "vue-axios";
import axios from "axios";
import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import moment from "moment-timezone";
import VuePapaParse from 'vue-papa-parse';
import VueLazyLoad from 'vue-lazyload';
import VueApexCharts from 'vue-apexcharts';
import i18n from './i18n';
import Element from 'element-ui';
import '@fortawesome/fontawesome-free/css/all.css';

Vue.use(Element)
Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

import App from "./App.vue";
import store from "./store";
import createRouter from "./router";
import helper from "./libs/helper";
Vue.config.productionTip = false;

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

// router, vuex
const router = createRouter(store);
store.$router = router;
sync(store, router);

// axios for vue auth
Vue.use(VueAxios, axios);

// tooltip
Vue.use(VTooltip);

// papaparse
Vue.use(VuePapaParse);

//image lazy
Vue.use(VueLazyLoad);

// date picker
const datepickerOptions = {};
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

Vue.filter("sizeDisplay", size => `${helper.sizeDisplay(size)}`);
Vue.filter("numberDisplay", num => `${helper.numberDisplay(num)}`);
Vue.filter("moneyDisplay", num => `${helper.moneyDisplay(num)}`);
Vue.filter("shortMoneyDisplay", num => `${helper.shortMoneyDisplay(num)}`);
Vue.filter(
  "priceDisplay",
  (num, currency) => `${helper.priceDisplay(num, currency)}`
);

Vue.filter(
  "percentDisplay",
  (num, currency) => `${helper.percentDisplay(num, currency)}`
);
Vue.filter(
  "numberDisplayFloat",
  (num, position) => `${helper.numberDisplayFloat(num, position)}`
);
Vue.filter("dateDisplay", num => `${helper.dateDisplay(num)}`);
Vue.filter("shortDateDisplay", num => `${helper.shortDateDisplay(num)}`);
Vue.filter("datetimeDisplay", (num, locale) => `${helper.datetimeDisplay(num, locale)}`);
Vue.filter("badgeStatus", value => {
  const statuses = {
    pending: "secondary",
    uploading: "info",
    draft: "primary",
    under_review: "warning",
    live: "success",
    failed: "danger",
    rejected: "danger"
  };

  return `badge badge-${statuses[value] || "secondary"}`;
});
Vue.filter("backgroundColor", value => `bg-${value}`);

new Vue({
  router,
  store,
  render: h => h(App),
  i18n
}).$mount("#main-wrapper");
